(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/helper-get-game-url/assets/javascripts/get-game-url.js') >= 0) return;  svs.modules.push('/components/lb-utils/helper-get-game-url/assets/javascripts/get-game-url.js');
"use strict";


const _getAllServerImports = () => {
  const path = require('path');
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  const trinidadRequire = trinidad.components.require;
  const localRequire = file => require(path.join(__dirname, file));
  return Object.freeze({
    getLogger: trinidad.logger,
    dateFnsInstance: trinidadRequire('libs', 'date-fns').api,
    urlMapping: trinidad.urlMapping,
    products: trinidadRequire('utils', 'products'),
    racingNavigation: localRequire('../../../../racing/race-navigation/assets/javascripts/location.es6'),
    racingServiceParse: localRequire('../../../../racing/race-service/assets/javascripts/utils/parse.es6')
  });
};
const _getAllClientImports = svs => Object.freeze({
  getLogger: svs.core.log.getLogger,
  dateFnsInstance: dateFns,
  urlMapping: svs.core.urlMapping,
  products: svs.utils.products,
  racingNavigation: svs.racing.navigation.location,
  racingServiceParse: svs.racing.raceService.utils.parse
});
const _ref = svs.isServer ? _getAllServerImports() : _getAllClientImports(svs),
  getLogger = _ref.getLogger,
  dateFnsInstance = _ref.dateFnsInstance,
  urlMapping = _ref.urlMapping,
  productIds = _ref.products.productIds,
  racingNavigation = _ref.racingNavigation,
  racingServiceParse = _ref.racingServiceParse;
const logger = getLogger('lb-utils:helper-get-game-url');
const ODDSET_SPORTSBOOK = 34;
const CASINO = 1001;
const BINGO_M = 16;
const BINGO_CLASSIC_SINGLE = 71;
const BINGO_CLASSIC = 72;
const BINGO_PATTERN_SINGLE = 73;
const BINGO_PATTERN = 74;
const BINGO_VARIANT_SINGLE = 75;
const BINGO_VARIANT = 76;
const POKER = 80;
const product2urlMapping = {
  [productIds.POWERPLAY]: 'powerplayHome',
  [productIds.T8]: 'topptipsetHome',
  [productIds.T8STRYK]: 'topptipsetHome',
  [productIds.T8EXTRA]: 'topptipsetHome',
  [productIds.EUROPATIPSET]: 'europatipsetHome',
  [productIds.STRYKTIPSET]: 'stryktipsetHome',
  [productIds.CHALLENGE]: 'challengeHome',
  [productIds.BOMBEN]: 'bombenHome',
  [productIds.MATCHEN]: 'matchenHome',
  [productIds.MALTIPSET]: 'maltipsetHome',
  [productIds.RACING]: 'racing',
  [productIds.FULLTRAFF]: 'fulltraffHome',
  [ODDSET_SPORTSBOOK]: 'oddsetSportsbookHome',
  [CASINO]: 'casinoHome',
  [BINGO_M]: 'bingoHome',
  [BINGO_CLASSIC_SINGLE]: 'bingoHome',
  [BINGO_CLASSIC]: 'bingoHome',
  [BINGO_PATTERN_SINGLE]: 'bingoHome',
  [BINGO_PATTERN]: 'bingoHome',
  [BINGO_VARIANT_SINGLE]: 'bingoHome',
  [BINGO_VARIANT]: 'bingoHome',
  [POKER]: 'pokerHome'
};

function buildGameUrl(_ref2) {
  let productId = _ref2.productId,
    _ref2$drawNumber = _ref2.drawNumber,
    drawNumber = _ref2$drawNumber === void 0 ? null : _ref2$drawNumber,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? null : _ref2$options,
    _ref2$novaSubmitToggl = _ref2.novaSubmitToggle,
    novaSubmitToggle = _ref2$novaSubmitToggl === void 0 ? false : _ref2$novaSubmitToggl;
  const _ref3 = options || {},
    _ref3$subPath = _ref3.subPath,
    subPath = _ref3$subPath === void 0 ? '' : _ref3$subPath,
    _ref3$search = _ref3.search,
    search = _ref3$search === void 0 ? '' : _ref3$search;
  const _product2urlMapping = product2urlMapping;
  const baseUrl = urlMapping.get(_product2urlMapping[productId]) || '/';
  const novaPowerplayBaseUrl = urlMapping.get('novaPowerplayHome');
  const searchObj = new URLSearchParams(search);
  searchObj.set('product', productId);
  switch (productId) {
    case productIds.EUROPATIPSET:
    case productIds.STRYKTIPSET:
    case productIds.FULLTRAFF:
    case productIds.BOMBEN:
      searchObj.delete('product');
    case productIds.T8:
    case productIds.T8STRYK:
    case productIds.T8EXTRA:
      if (drawNumber) {
        searchObj.set('draw', drawNumber);
      }
      return "".concat(baseUrl).concat(subPath, "?").concat(searchObj);
    case productIds.POWERPLAY:
      {
        searchObj.delete('product');
        if (novaSubmitToggle && novaPowerplayBaseUrl) {
          return "".concat(novaPowerplayBaseUrl).concat(drawNumber ? "/".concat(drawNumber) : '').concat(subPath);
        }
        if (drawNumber) {
          searchObj.set('draw', drawNumber);
        }
        return "".concat(baseUrl).concat(subPath, "?").concat(searchObj);
      }

    case productIds.CHALLENGE:
    case productIds.MATCHEN:
      return "".concat(baseUrl).concat(drawNumber ? "/spela/".concat(drawNumber) : '').concat(subPath).concat(search ? "?".concat(search) : '');
    case productIds.MALTIPSET:
      return "".concat(baseUrl).concat(drawNumber ? "/".concat(drawNumber) : '').concat(subPath).concat(search ? "?".concat(search) : '');
    case productIds.RACING:
      if (drawNumber) {
        return "".concat(baseUrl).concat(subPath).concat(drawNumber ? "/draw/".concat(drawNumber) : '').concat(search ? "?".concat(search) : '');
      }
      return "".concat(baseUrl === '/' && subPath ? '' : baseUrl).concat(subPath).concat(search ? "?".concat(search) : '');
    default:
      return "".concat(baseUrl === '/' && subPath ? '' : baseUrl).concat(subPath).concat(search ? "?".concat(search) : '');
  }
}

function getGameUrl(_ref4) {
  let productId = _ref4.productId,
    _ref4$drawNumber = _ref4.drawNumber,
    drawNumber = _ref4$drawNumber === void 0 ? null : _ref4$drawNumber,
    _ref4$options = _ref4.options,
    options = _ref4$options === void 0 ? null : _ref4$options;
  const novaSubmitToggle = svs.core.detect.feature('ft-marketplace-nova-submit-game');
  return buildGameUrl({
    productId,
    drawNumber,
    options,
    novaSubmitToggle
  });
}

async function getGameUrlServer(_ref5) {
  var _options$req;
  let productId = _ref5.productId,
    _ref5$drawNumber = _ref5.drawNumber,
    drawNumber = _ref5$drawNumber === void 0 ? null : _ref5$drawNumber,
    _ref5$options = _ref5.options,
    options = _ref5$options === void 0 ? null : _ref5$options;
  const novaSubmitToggle = await (options === null || options === void 0 || (_options$req = options.req) === null || _options$req === void 0 ? void 0 : _options$req.feature('ft-marketplace-nova-submit-game', options === null || options === void 0 ? void 0 : options.req));
  return buildGameUrl({
    productId,
    drawNumber,
    options,
    novaSubmitToggle
  });
}

function getRacingGameUrl(_ref6) {
  var _meeting$track;
  let race = _ref6.race,
    _ref6$userProduct = _ref6.userProduct,
    userProduct = _ref6$userProduct === void 0 ? null : _ref6$userProduct;
  const _ref7 = race || {},
    raceNumber = _ref7.raceNumber,
    meeting = _ref7.meeting;
  if (!raceNumber || !(meeting !== null && meeting !== void 0 && meeting.date) || !(meeting !== null && meeting !== void 0 && (_meeting$track = meeting.track) !== null && _meeting$track !== void 0 && _meeting$track.pathName)) {
    logger.info('Error in getRacingGameUrl(): Missing race-data');
    return '';
  }
  const format = dateFnsInstance.format,
    parseISO = dateFnsInstance.parseISO;
  const locationToUrl = racingNavigation.locationToUrl,
    buildCouponLocation = racingNavigation.buildCouponLocation;
  const parseGameType = racingServiceParse.parseGameType;
  const baseUrl = urlMapping.get('racing') || '';
  const day = format(parseISO(meeting.date), 'yyyy-MM-dd');
  const trackName = meeting.track.pathName;
  const gameType = userProduct ? parseGameType({
    userProduct
  }) : undefined;
  return baseUrl + locationToUrl(buildCouponLocation({
    day,
    trackName,
    raceNumber,
    gameType
  }));
}

if (svs.isServer) {
  module.exports = {
    buildGameUrl,
    getGameUrl,
    getGameUrlServer,
    getRacingGameUrl
  };
} else {
  setGlobal('svs.components.lbUtils', {
    getGameUrl,
    getRacingGameUrl
  });
}

 })(window);